import { render, staticRenderFns } from "./ConfirmWasteCollectionModal.vue?vue&type=template&id=04fedec6&"
import script from "./ConfirmWasteCollectionModal.vue?vue&type=script&lang=js&"
export * from "./ConfirmWasteCollectionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports